import React, { Component } from "react";
import axios from "axios";
import { APIURL } from "../../../config/config";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import NumberFormat from "react-number-format";
import { AlertError, AlertWarning } from "../../Alert/Alert";
import Swal from "sweetalert2";
import { CarUtil } from "../../../utils/carUtil";

class SalesEdit extends Component {
  constructor(props) {
    super(props);

    this.state = {
      user: this.props.user,
      lists: [],
      car_sell_type: [],
      insurance_company: [],
      insurance_type: [],
      count_period: [],
      duration_period: [],
      customer_list: [],
      car_sell_list_pay: [],
      car_status: [],
      sales_type: [],
      car: "",
      bank: [],
      car_sell: "",
      province: [],
      customer: {},
      load_data: true,
      danger: false,
      car_id: this.props.car_sell.car_id,
      car_sell_id: this.props.car_sell.car_sell_id,
      car_brand_name: this.props.car_sell.car_brand_name,
      car_model_name: this.props.car_sell.car_model_name,
      car_sub_model_name: this.props.car_sell.car_sub_model_name,
      car_year_name: this.props.car_sell.car_year_name,
      car_gear_name: this.props.car_sell.car_gear_name,
      car_color_name: this.props.car_sell.car_color_name,
      car_miles: this.props.car_sell.car_miles,
      car_license_plate_new: this.props.car_sell.car_license_plate_new,
      province_name_new: this.props.car_sell.province_name_new,
      customer_name: this.props.car_sell.customer_name,
      customer_lastname: this.props.car_sell.customer_lastname,
      customer_card_id: this.props.car_sell.customer_card_id,
      customer_mobile: this.props.car_sell.customer_mobile,
      customer_address: this.props.car_sell.customer_address,
      person_vat_id: this.props.car_sell.person_vat_id,
      car_sell_type_id: this.props.car_sell.car_sell_type_id,
      insurance_company_id: this.props.car_sell.insurance_company_id,
      insurance_type_id:
        this.props.car_sell.insurance_type_id === 0
          ? "0"
          : this.props.car_sell.insurance_type_id,
      count_period_id: this.props.car_sell.count_period_id,
      duration_period_id: this.props.car_sell.duration_period_id,
      bank_finance_id: this.props.car_sell.bank_finance_id,
      car_status_id: this.props.car_sell.car_status_id,
      real_sell_price: this.props.car_sell.real_sell_price,
      normal_sell_price: this.props.car_sell.normal_sell_price,
      car_sell_discount: this.props.car_sell.car_sell_discount,
      rate_finance: this.props.car_sell.rate_finance,
      insurance_pa: this.props.car_sell.insurance_pa,
      tax_rate_finance: this.props.car_sell.tax_rate_finance,
      total_rate_finance: this.props.car_sell.total_rate_finance,
      sum_down: this.props.car_sell.sum_down,
      insurance_price: this.props.car_sell.insurance_price,
      cost_finance: this.props.car_sell.cost_finance,
      cost_transfer: this.props.car_sell.cost_transfer,
      cost_period_month: this.props.car_sell.cost_period_month,
      total_cost_period_call: this.props.car_sell.total_cost_period_call,
      total_outof_car: this.props.car_sell.total_outof_car,
      balance_debt: this.props.car_sell.balance_debt,
      date_promise:
        this.props.car_sell.date_promise !== null &&
        this.props.car_sell.date_promise !== "0000-00-00"
          ? this.props.car_sell.date_promise
          : null,
      insurance_buy: this.props.car_sell.insurance_buy,
      promotion_name: this.props.car_sell.promotion_name,
      promotion_oil: this.props.car_sell.promotion_oil,
      car_over_sales: this.props.car_sell.car_over_sales,
      car_excess_amount: this.props.car_sell.car_excess_amount,
      customer_cash: this.props.car_sell.customer_cash,
      car_external_commission: this.props.car_sell.car_external_commission,
      startDatePromiseEdit:
        this.props.car_sell.date_promise !== null &&
        this.props.car_sell.date_promise !== "0000-00-00"
          ? new Date(this.props.car_sell.date_promise)
          : null, //moment(),
      promotion_list: [
        { promotion_id: 0, promotion_name: "ไม่มี" },
        { promotion_id: 3, promotion_name: "1แถม1" },
        { promotion_id: 4, promotion_name: "ช่วยผ่อน 6 เดือน" },
        { promotion_id: 7, promotion_name: "ส่วนลด2หมื่น" },
        { promotion_id: 9, promotion_name: "โปรขับฟรีนำ้มัน 6 เดือน" },
        { promotion_id: 10, promotion_name: "ส่วนลด 18,000" },
      ],
      gearbox_warranty_list: [
        {
          gearbox_warranty_id: 1,
          gearbox_warranty_name: "ไม่รับประกันเครื่องเกียร์",
        },
        {
          gearbox_warranty_id: 2,
          gearbox_warranty_name: "รับประกันเครื่องเกียร์",
        },
      ],
      tent_warranty_list: [
        { tent_warranty_id: 1, tent_warranty_name: "ไม่ระบุ" },
        { tent_warranty_id: 2, tent_warranty_name: "มี" },
        { tent_warranty_id: 3, tent_warranty_name: "ไม่มี" },
      ],
      tent_warranty: this.props.car_sell.tent_warranty,
      insuranceStartDate:
        this.props.car_sell.insurance_start_date === "0000-00-00"
          ? null
          : new Date(this.props.car_sell.insurance_start_date),
      insurance_start_date:
        this.props.car_sell.insurance_start_date === "0000-00-00"
          ? null
          : new Date(this.props.car_sell.insurance_start_date),
      insurance_tel: this.props.car_sell.insurance_tel,
      gearbox_warranty:
        this.props.car_sell.gearbox_warranty === null
          ? ""
          : this.props.car_sell.gearbox_warranty,
      gearbox_bank_name:
        this.props.car_sell.gearbox_bank_name === null
          ? ""
          : this.props.car_sell.gearbox_bank_name,
      pay_advance_finance: this.props.car_sell.pay_advance_finance,
      promotion_oil_cost: this.props.car_sell.promotion_oil_cost,
      promotion_discount_cost: this.props.car_sell.promotion_discount_cost,
      promotion_help_cost: this.props.car_sell.promotion_help_cost,
      promotion_sum:
        Number(this.props.car_sell.promotion_oil_cost) +
        Number(this.props.car_sell.promotion_discount_cost) +
        Number(this.props.car_sell.promotion_help_cost),
    };
    this.handleDatePromise = this.handleDatePromise.bind(this);
    this.handleInsuranceStartDate = this.handleInsuranceStartDate.bind(this);
    this.onInsuranceBuyChanged = this.onInsuranceBuyChanged.bind(this);
    this.handleOnSubmitCarSellEdit = this.handleOnSubmitCarSellEdit.bind(this);
    this.getNormalSellPrice = this.getNormalSellPrice.bind(this);
    this.onInputChangeCarSellEdit = this.onInputChangeCarSellEdit.bind(this);
    this.calPromotion = this.calPromotion.bind(this);
    // console.log(this.props.car_sell)
  }

  calPromotion() {
    const { promotion_oil_cost, promotion_discount_cost, promotion_help_cost } =
      this.state;

    // console.log('promotion_oil_cost=', promotion_oil_cost, typeof promotion_oil_cost)
    let promotion_sum =
      parseInt(promotion_oil_cost, 10) +
      parseInt(promotion_discount_cost, 10) +
      parseInt(promotion_help_cost, 10);
    let promotion_diff = 0;

    if (promotion_sum === 18000) {
      this.setState({
        promotion_sum: promotion_sum,
        promotion_diff: promotion_diff,
        // real_sell_price: real_sell_price_new === 0 ? real_sell_price : real_sell_price_new
      });
      return;
    } else if (promotion_sum > 18000) {
      this.setState({
        promotion_sum: promotion_sum,
        promotion_diff: promotion_diff,
        // real_sell_price: real_sell_price_new === 0 ? real_sell_price : real_sell_price_new
      });
      AlertError("ยอดโปรโมชั่นรวมต้องไม่เกิน 18,000 บาท");
      return;
    } else if (promotion_sum < 18000) {
      promotion_diff = 18000 - Number(promotion_sum);

      let real_sell_price = this.state.real_sell_price;
      let real_sell_price_with_diff =
        Number(real_sell_price) + Number(promotion_diff);
      let info =
        "ยอดโปรโมชั้นเหลือ " +
        promotion_diff +
        " จะถูกเพิ่มเข้าที่ราคาขายรวมเป็น " +
        real_sell_price;
      Swal.fire({
        title: info,
        icon: "success",
        showConfirmButton: true,
        showCancelButton: true,
      }).then((result) => {
        if (result.value) {
          this.setState(
            {
              real_sell_price: real_sell_price_with_diff,
              promotion_sum: promotion_sum,
              promotion_diff: promotion_diff,
            },
            () => this.handleOnChangeCarPriceOutof()
          );
        }
      });
    }
  }

  handleDatePromise(date) {
    //alert (date);
    this.setState({
      startDatePromiseEdit: date,
      date_promise: date,
    });
  }

  handleInsuranceStartDate(date) {
    //alert (date);
    this.setState({
      insuranceStartDate: date,
      insurance_start_date: date,
    });
  }

  handleOnSubmitCarSellEdit(event) {
    event.preventDefault();
    // alert(event.target.customer_name.value);
    // let that = this ;
    let real_sell_price = event.target.real_sell_price.value;

    let promotion_oil_cost = this.state.promotion_oil_cost;
    let promotion_discount_cost = this.state.promotion_discount_cost;
    let promotion_help_cost = this.state.promotion_help_cost;
    let promotion_sum =
      Number(promotion_oil_cost) +
      Number(promotion_discount_cost) +
      Number(promotion_help_cost);
    // let promotion_diff =  this.state.promotion_diff

    // console.log('promotion_diff=', promotion_diff, typeof promotion_diff)

    if (promotion_sum > 18000) {
      AlertError("ยอดโปรโมชั่นรวมต้องไม่เกิน 18,000 บาท");
      return;
    }

    let car_sell_type_id = event.target.car_sell_type_id.value;
    let bank_finance_id = event.target.bank_finance_id.value;
    let normal_sell_price = event.target.normal_sell_price.value;

    let car_sell_discount = event.target.car_sell_discount.value;
    let rate_finance = event.target.rate_finance.value;
    let insurance_pa = event.target.insurance_pa.value;
    let tax_rate_finance = event.target.tax_rate_finance.value;
    let total_rate_finance = event.target.total_rate_finance.value;
    let sum_down = event.target.sum_down.value;
    let insurance_company_id = event.target.insurance_company_id.value;
    let insurance_type_id = event.target.insurance_type_id.value;
    let insurance_price = event.target.insurance_price.value;
    let cost_finance = event.target.cost_finance.value;
    let cost_transfer = 0; // event.target.cost_transfer.value
    let cost_period_month = 0; //event.target.cost_period_month.value
    let count_period_id = ""; //event.target.count_period_id.value
    let total_cost_period_call = 0; //event.target.total_cost_period_call.value
    //let duration_period_id = event.target.duration_period_id.value
    let duration_period_id =
      car_sell_type_id === "1" ? 99 : event.target.duration_period_id.value; // car_sell_type_id===1 // 1.สด 2.ผ่อน
    let total_outof_car = event.target.total_outof_car.value;
    let balance_debt = event.target.balance_debt.value;
    let car_status_id = event.target.car_status_id.value;
    let date_promise = event.target.date_promise.value;
    let insurance_buy = event.target.insurance_buy.value;
    let promotion_name = event.target.promotion_name.value;
    let promotion_oil = this.state.promotion_oil;

    //alert('car_status_id='+car_status_id); return;

    let car_over_sales = Number(event.target.car_over_sales.value);
    let car_excess_amount = Number(event.target.car_excess_amount.value);
    let customer_cash = Number(event.target.customer_cash.value);
    let car_external_commission = Number(
      event.target.car_external_commission.value
    );

    let insurance_start_date = event.target.insurance_start_date.value;
    let insurance_tel = event.target.insurance_tel.value;
    let pay_advance_finance = event.target.pay_advance_finance.value;
    let gearbox_warranty = event.target.gearbox_warranty.value;
    let gearbox_bank_name = event.target.gearbox_bank_name.value;

    let tent_warranty = event.target.tent_warranty.value;

    if (car_sell_type_id === "") {
      return;
    }

    event.target.car_sell_type_id.value = "";
    event.target.bank_finance_id.value = "";
    event.target.normal_sell_price.value = "";
    event.target.real_sell_price.value = "";
    event.target.car_sell_discount.value = "";
    event.target.rate_finance.value = "";
    event.target.insurance_pa.value = "";
    event.target.tax_rate_finance.value = "";
    event.target.total_rate_finance.value = "";
    event.target.sum_down.value = "";
    event.target.insurance_company_id.value = "";
    event.target.insurance_type_id.value = "";
    event.target.insurance_price.value = "";
    event.target.cost_finance.value = "";
    // event.target.cost_transfer.value = ""
    // event.target.cost_period_month.value = ""
    // event.target.count_period_id.value = ""
    // event.target.total_cost_period_call.value = ""
    event.target.duration_period_id.value = "";
    event.target.total_outof_car.value = "";
    event.target.balance_debt.value = "";
    event.target.date_promise.value = "";
    event.target.car_status_id.value = "";
    event.target.promotion_name.value = "";
    event.target.car_external_commission.value = "";
    event.target.pay_advance_finance.value = "";
    //
    event.target.promotion_oil_cost.value = "";
    event.target.promotion_discount_cost.value = "";
    event.target.promotion_help_cost.value = "";
    event.target.tent_warranty.value = "";

    let data = {
      car_sell_type_id: car_sell_type_id,
      bank_finance_id: bank_finance_id,
      normal_sell_price: normal_sell_price,
      real_sell_price: real_sell_price,
      car_sell_discount: car_sell_discount,
      rate_finance: rate_finance,
      insurance_pa: insurance_pa,
      tax_rate_finance: tax_rate_finance,
      total_rate_finance: total_rate_finance,
      sum_down: sum_down,
      insurance_company_id: insurance_company_id,
      insurance_type_id: insurance_type_id,
      insurance_price: insurance_price,
      cost_finance: cost_finance,
      cost_transfer: cost_transfer,
      cost_period_month: cost_period_month,
      count_period_id: count_period_id,
      total_cost_period_call: total_cost_period_call,
      duration_period_id: duration_period_id,
      total_outof_car: total_outof_car,
      balance_debt: balance_debt,
      date_promise: date_promise,
      car_status_id: car_status_id,
      user_updated: this.props.user.user,
      insurance_buy: insurance_buy,
      promotion_name: promotion_name,
      //
      car_over_sales: car_over_sales, //ยอดขายเกิน
      car_excess_amount: car_excess_amount, // ยอดจัดเกิน
      customer_cash: customer_cash, //เงินคืนลูกค้า
      car_external_commission: car_external_commission, // ค่านายหน้า ภายนอก
      car_id: this.state.car_id,
      insurance_start_date: insurance_start_date,
      insurance_tel: insurance_tel,
      promotion_oil: promotion_oil,
      pay_advance_finance: pay_advance_finance,
      promotion_oil_cost: promotion_oil_cost,
      promotion_discount_cost: promotion_discount_cost,
      promotion_help_cost: promotion_help_cost,
      gearbox_warranty: gearbox_warranty,
      gearbox_bank_name: gearbox_bank_name,
      tent_warranty: tent_warranty,
    };

    // console.log(data); return;
    axios
      .put(
        APIURL + "/car_sell/car_sell_edit_detail/" + this.state.car_sell_id,
        data
      )
      .then((response) => {
        if (response.status === 200) {
          this.props.onToggle();
          this.props.onLoadCarSellById();
        }
      })
      .catch((error) => {
        alert("พบข้อผิดพลาด : " + error);
      });
  }

  onInputChangeCarSellEdit(event) {
    event.preventDefault();

    if (event.target.id === "car_sell_type_id") {
      this.setState({ car_sell_type_id: this.refs.car_sell_type_id.val });
    } else if (event.target.id === "bank_finance_id") {
      this.setState({ bank_finance_id: this.refs.bank_finance_id.val });
    } else if (event.target.id === "normal_sell_price") {
      this.setState({ normal_sell_price: this.refs.normal_sell_price.val });
    } else if (event.target.id === "real_sell_price") {
      this.setState({ real_sell_price: this.refs.real_sell_price.val });
    } else if (event.target.id === "rate_finance") {
      this.setState({ rate_finance: this.refs.rate_finance.val });
    } else if (event.target.id === "insurance_pa") {
      this.setState({ insurance_pa: this.refs.insurance_pa.val });
    } else if (event.target.id === "tax_rate_finance") {
      this.setState({ tax_rate_finance: this.refs.tax_rate_finance.val });
    } else if (event.target.id === "sum_down") {
      this.setState({ sum_down: this.refs.sum_down.val });
    } else if (event.target.id === "insurance_company_id") {
      this.setState({
        insurance_company_id: this.refs.insurance_company_id.val,
      });
    } else if (event.target.id === "insurance_type_id") {
      //this.setState({insurance_type_id: this.refs.insurance_type_id.val})
      this.setState({ insurance_type_id: event.target.value });
    } else if (event.target.id === "insurance_price") {
      this.setState({ insurance_price: this.refs.insurance_price.val });
    } else if (event.target.id === "cost_finance") {
      this.setState({ cost_finance: this.refs.cost_finance.val });
    } else if (event.target.id === "cost_transfer") {
      this.setState({ cost_transfer: this.refs.cost_transfer.val });
    } else if (event.target.id === "cost_period_month") {
      this.setState({ cost_period_month: this.refs.cost_period_month.val });
    } else if (event.target.id === "count_period_id") {
      this.setState({ count_period_id: this.refs.count_period_id.val });
    } else if (event.target.id === "duration_period_id") {
      this.setState({ duration_period_id: this.refs.duration_period_id.val });
    } else if (event.target.id === "car_status_id") {
      this.setState({ car_status_id: this.refs.car_status_id.val });
    } else if (event.target.id === "balance_debt") {
      this.setState({ balance_debt: this.refs.balance_debt.val });
    }
  }

  handleOnChangeCarSellEditPrice() {
    var real_sell_price = this.state.real_sell_price;
    var normal_sell_price = this.state.normal_sell_price;

    if (real_sell_price === "") real_sell_price = 0;

    var discount = 0;
    if (normal_sell_price !== "" && normal_sell_price > 0)
      discount = Number(normal_sell_price) - Number(real_sell_price);
    // else
    //    profite = 0

    this.setState(
      {
        car_sell_discount: discount,
      },
      () => {
        this.handleOnChangeCarPriceOutof();
      }
    );
  }

  handleOnChangeInsurancePriceEdit(insurance_price_old) {
    if (this.state.insurance_buy === "ซื้อเอง") {
      this.handleOnChangeCarPriceOutof();
    }
  }

  loadBankData() {
    axios
      .get(APIURL + "/bank/")
      .then((res) => this.setState({ bank: res.data }))
      .catch((error) => {
        this.setState({ bank: [] });
      });
  }

  loadSalesTypeData() {
    axios
      .get(APIURL + "/sales_type/")
      .then((res) => {
        this.setState({ sales_type: res.data });
      })
      .catch((error) => {
        this.setState({ sales_type: [] });
      });
  }

  loadCarSellTypeData() {
    axios
      .get(APIURL + "/car_sell_type/")
      .then((res) => {
        this.setState({ car_sell_type: res.data });
      })
      .catch((error) => {
        this.setState({ car_sell_type: [] });
      });
  }

  loadInsuranceCompanyData() {
    axios
      .get(APIURL + "/insurance_company/")
      .then((res) => {
        this.setState({ insurance_company: res.data });
        //console.log(res.data)
        //alert (res.data)
      })
      .catch((error) => {
        this.setState({ insurance_company: [] });
      });
  }

  loadInsuranceTypeData() {
    axios
      .get(APIURL + "/insurance_type/")
      .then((res) => {
        this.setState({ insurance_type: res.data });
      })
      .catch((error) => {
        this.setState({ insurance_type: [] });
      });
  }

  loadCountPeriodData() {
    axios
      .get(APIURL + "/count_period/")
      .then((res) => {
        this.setState({ count_period: res.data });
      })
      .catch((error) => {
        this.setState({ count_period: [] });
      });
  }

  loadDurationPeriodData() {
    axios
      .get(APIURL + "/duration_period/")
      .then((res) => {
        this.setState({ duration_period: res.data });
      })
      .catch((error) => {
        this.setState({ duration_period: [] });
      });
  }

  loadCarSellListPayData() {
    axios
      .get(APIURL + "/car_sell_list_pay/")
      .then((res) => {
        this.setState({ car_sell_list_pay: res.data });
      })
      .catch((error) => {
        this.setState({ car_sell_list_pay: [] });
      });
  }

  loadCarStatusData() {
    axios
      .get(APIURL + "/car_status/sell/1")
      .then((res) => {
        this.setState({ car_status: res.data });
      })
      .catch((error) => {
        this.setState({ car_status: [] });
      });
  }

  /*loadData () {
        axios.get(APIURL + '/car_sell/')
            .then(res => {
                 console.log(res.data)
                 this.setState({lists: res.data})
            }).catch(error => {
              console.log(error)
            this.setState({lists: []})
        })
    }*/

  /*componentWillMount() {
        this.setState({
            user: JSON.parse(this.props.user)
        });
    }*/

  componentDidMount() {
    //componentDidUpdate(){
    //if(this.state.load_data)
    //this.loadCarData()
    //console.log('SaleEdit componentDidMount')

    this.loadBankData();
    this.loadCarSellTypeData();
    this.loadInsuranceCompanyData();
    this.loadInsuranceTypeData();
    this.loadCountPeriodData();
    this.loadDurationPeriodData();
    this.loadCarSellListPayData();
    this.loadCarStatusData();
    this.loadSalesTypeData();
  }

  componentWillUnmount() {
    // console.log('SaleEdit componentWillUnmount')
  }

  onInsuranceBuyChanged(e) {
    //console.log(e.currentTarget.value)
    var insurance_buy = e.currentTarget.value;
    this.setState(
      {
        insurance_buy: insurance_buy,
      },
      () => {
        this.handleOnChangeCarPriceOutof();
      }
    );
  }

  handleOnChangeCarPriceOutof() {
    let sum_down = this.state.sum_down; // ยอดดาวน์
    let insurance_price =
      this.state.insurance_buy === "ประกันแถม" ? 0 : this.state.insurance_price; //ราคาประกัน
    let cost_finance = this.state.cost_finance; //ค่าจัดไฟแนนซ์
    let rate_finance = Number(this.state.rate_finance); // ยอดจัดไฟแนนซ์
    let cost_transfer = 0; //this.state.cost_transfer //ค่าโอน
    // var car_pay_all = this.state.car_pay_all // เงินที่จ่ายไปแล้ว เงินจอง เงินมัดจำ
    let real_sell_price = Number(this.state.real_sell_price);
    let normal_sell_price = Number(this.state.normal_sell_price);
    let car_external_commission = Number(this.state.car_external_commission); //ค่านายหน้า ภายนอก
    let pay_advance_finance = Number(this.state.pay_advance_finance); // เก็บค่างวดล่วงหน้า

    // var car_excess_amount = Number(this.state.car_excess_amount) //ยอดจัดเกิน
    let customer_cash = 0; // คิดเงินคืนลูกค้า

    if (sum_down === "") sum_down = 0;

    if (insurance_price === "") insurance_price = 0;

    if (cost_finance === "") cost_finance = 0;

    if (cost_transfer === "") cost_transfer = 0;

    let profite_total_outof_car = 0; // เงินออกรถ

    if (sum_down !== "" && sum_down > 0) {
      profite_total_outof_car =
        Number(sum_down) +
        Number(insurance_price) +
        Number(cost_finance) +
        Number(cost_transfer) +
        car_external_commission +
        pay_advance_finance;
    } else if (sum_down === 0) {
      profite_total_outof_car =
        Number(insurance_price) +
        Number(cost_finance) +
        Number(cost_transfer) +
        car_external_commission +
        pay_advance_finance;
    }

    if (this.state.car_sell_type_id === "1") {
      //ประเภทการขาย 1 = เงินสด
      profite_total_outof_car =
        Number(real_sell_price) +
        Number(insurance_price) +
        Number(cost_finance) +
        Number(cost_transfer) +
        car_external_commission +
        pay_advance_finance;
    }

    let discount = 0;
    //var profite_sum_down = 0

    if (normal_sell_price !== "" && normal_sell_price > 0) {
      discount = Number(normal_sell_price) - Number(real_sell_price);
    }

    var real_discount = discount >= 0 ? discount : 0;

    var car_over_sales = 0;
    if (real_sell_price > normal_sell_price)
      car_over_sales = real_sell_price - normal_sell_price;

    var car_excess_amount = 0; // ยอดจัดเกิน
    if (rate_finance > real_sell_price) {
      //profite_sum_down = 0
      car_excess_amount = rate_finance - real_sell_price;
    } else {
      // ยอดจัดไม่เกินยอดขาย
      // rate_finance + sum_down >= real_sell_price
    }

    // ยอดจัดเกิน รวมเงินออกรถ
    if (car_excess_amount >= profite_total_outof_car) {
      customer_cash = car_excess_amount - profite_total_outof_car;
      profite_total_outof_car = 0;
    } else {
      //ราคา ออกรถมากกว่า
      customer_cash = 0;
      profite_total_outof_car =
        Number(profite_total_outof_car) - Number(car_excess_amount);
    }

    //var payMore = real_sell_price - ( rate_finance + profite_total_outof_car)

    /*var balance_debt = Number(profite_total_outof_car)
    if(payMore > 0){
      balance_debt += payMore
    }*/

    this.setState({
      total_outof_car: profite_total_outof_car, // รวมออกรถ/บาท
      customer_cash: customer_cash,
      // balance_debt: balance_debt,
      car_sell_discount: real_discount,
      car_excess_amount: car_excess_amount,
      car_over_sales: car_over_sales,
    });
  }

  getNormalSellPrice() {
    var normal_sell_price = null;
    if (this.state.user.type === "admin") {
      normal_sell_price = (
        <NumberFormat
          className="form-control"
          thousandSeparator={true}
          prefix={"฿"}
          //placeholder="กรอกค่าโอน"
          min={0}
          max={1000000000}
          step={1000}
          size={10}
          allowNegative={false}
          value={this.state.normal_sell_price}
          onValueChange={(values) => {
            const { value } = values;

            //TODO:
            //console.log(this.state.user.type)

            this.setState({ normal_sell_price: value }, () => {
              this.handleOnChangeCarSellEditPrice();
            });
          }}
        />
      );
    } else {
      normal_sell_price = (
        <NumberFormat
          className="form-control"
          thousandSeparator={true}
          prefix={"฿"}
          //placeholder="กรอกค่าโอน"
          displayType={"text"}
          allowNegative={false}
          value={this.state.normal_sell_price}
        />
      );
    }
    return normal_sell_price;
  }

  render() {
    let bank_finance_list = this.state.bank.map((bank, index) => {
      return (
        <option key={index} value={bank.bank_id}>
          {bank.bank_name}
        </option>
      );
    });

    let car_sell_type_list = this.state.car_sell_type.map(
      (car_sell_type, index) => {
        return (
          <option key={index} value={car_sell_type.car_sell_type_id}>
            {car_sell_type.car_sell_type_name}
          </option>
        );
      }
    );

    let insurance_company_list = this.state.insurance_company.map(
      (insurance_company, index) => {
        return (
          <option key={index} value={insurance_company.insurance_company_id}>
            {insurance_company.insurance_company_name}
          </option>
        );
      }
    );

    let insurance_type_list = this.state.insurance_type.map(
      (insurance_type, index) => {
        return (
          <option key={index} value={insurance_type.insurance_type_id}>
            {insurance_type.insurance_type_name}
          </option>
        );
      }
    );

    /* var count_period_list = this.state.count_period.map((count_period,index)=>{
            return(
                <option key={index} value={count_period.count_period_id}>{count_period.count_period_name}</option>
            )
        }) */

    let duration_period_list = this.state.duration_period.map(
      (duration_period, index) => {
        return (
          <option key={index} value={duration_period.duration_period_id}>
            {duration_period.duration_period_name}
          </option>
        );
      }
    );

    let car_sell_status_list = this.state.car_status.map(
      (car_status, index) => {
        return (
          <option key={index} value={car_status.car_status_id}>
            {car_status.car_status_name}
          </option>
        );
      }
    );

    let promotion_list = this.state.promotion_list.map((promotion, index) => {
      return (
        <option key={index} value={promotion.promotion_name}>
          {" "}
          {promotion.promotion_name}{" "}
        </option>
      );
    });

    let normal_sell_price = this.getNormalSellPrice();

    let gearbox_warranty_list = this.state.gearbox_warranty_list.map(
      (gearbox_warranty, index) => {
        return (
          <option key={index} value={gearbox_warranty.gearbox_warranty_name}>
            {" "}
            {gearbox_warranty.gearbox_warranty_name}{" "}
          </option>
        );
      }
    );

    let tent_warranty_list = this.state.tent_warranty_list.map(
      (tent_warranty, index) => {
        return (
          <option key={index} value={tent_warranty.tent_warranty_name}>
            {" "}
            {tent_warranty.tent_warranty_name}{" "}
          </option>
        );
      }
    );

    return (
      <form action="" method="post" onSubmit={this.handleOnSubmitCarSellEdit}>
        <div className="row">
          <div className="col-sm-12">
            <div className="card card-accent-warning">
              <div className="card-header">
                <strong>แก้ไขข้อมูลการขายรถ</strong>
              </div>

              <div className="card-block">
                <div className="row">
                  <div className="col-lg-12">
                    <div className="row">
                      <div className="form-group form-inline col-sm-4">
                        <label htmlFor="car_brand_name">ยี่ห้อ </label>
                        <span className="text-primary pl-5">
                          <strong>{this.state.car_brand_name}</strong>
                        </span>
                      </div>

                      <div className="form-group col-sm-4">
                        <label htmlFor="car_model_name">รุ่นรถ</label>
                        <span className="text-primary pl-5">
                          <strong>{this.state.car_model_name}</strong>
                        </span>
                      </div>

                      <div className="form-group col-sm-4">
                        <label htmlFor="car_sub_model_name">รุ่นย่อย </label>
                        <span className="text-primary pl-5">
                          <strong>{this.state.car_sub_model_name}</strong>
                        </span>
                      </div>
                    </div>

                    <div className="row">
                      <div className="form-group col-sm-4">
                        <label htmlFor="car_year_name">ปีรถ</label>
                        <span className="text-primary pl-5">
                          <strong>{this.state.car_year_name}</strong>
                        </span>
                      </div>

                      <div className="form-group col-sm-4">
                        <label htmlFor="car_gear_name">ระบบเกียร์</label>
                        <span className="text-primary pl-5">
                          <strong>{this.state.car_gear_name}</strong>
                        </span>
                      </div>

                      <div className="form-group col-sm-4">
                        <label htmlFor="car_color_name">สีรถ</label>
                        <span className="text-primary pl-5">
                          <strong>{this.state.car_color_name}</strong>
                        </span>
                      </div>
                    </div>

                    <div className="row">
                      <div className="form-group col-sm-4">
                        <label htmlFor="car_miles">เลขไมล์</label>
                        <span className="text-primary pl-5">
                          <strong>{this.state.car_miles}</strong>
                        </span>
                      </div>

                      <div className="form-group col-sm-4">
                        <label htmlFor="car_license_plate_new">
                          ป้ายทะเบียนรถ
                        </label>
                        <span className="text-primary pl-5">
                          <strong>{this.state.car_license_plate_new}</strong>
                        </span>
                      </div>

                      <div className="form-group col-sm-4">
                        <label htmlFor="province_name_new">จังหวัด</label>
                        <span className="text-primary pl-5">
                          <strong>{this.state.province_name_new}</strong>
                        </span>
                      </div>
                    </div>

                    <div className="row">
                      <div className="form-group col-sm-6">
                        <label htmlFor="customer_name">ชื่อลูกค้า</label>
                        <span className="text-primary pl-5">
                          <strong>{this.state.customer_name}</strong>
                        </span>
                      </div>

                      <div className="form-group col-sm-6">
                        <label htmlFor="customer_lastname">นามสกุลลูกค้า</label>
                        <span className="text-primary pl-5">
                          <strong>{this.state.customer_lastname}</strong>
                        </span>
                      </div>
                    </div>

                    <div className="row">
                      <div className="form-group col-sm-6">
                        <label htmlFor="customer_card_id">
                          เลขประจำตัวประชาชน
                        </label>
                        <span className="text-primary pl-5">
                          <strong>{this.state.customer_card_id}</strong>
                        </span>
                      </div>

                      <div className="form-group col-sm-6">
                        <label htmlFor="customer_mobile">เบอร์โทรศัพท์</label>
                        <span className="text-primary pl-5">
                          <strong>{this.state.customer_mobile}</strong>
                        </span>
                      </div>
                    </div>

                    <div className="row">
                      <div className="form-group col-sm-12">
                        <label htmlFor="customer_address">
                          ที่อยู่ปัจจุบัน
                        </label>
                        <span className="text-primary pl-5">
                          <strong>{this.state.customer_address}</strong>
                        </span>
                      </div>
                    </div>

                    <div className="row">
                      <div className="form-group col-sm-4">
                        <label htmlFor="person_vat_id">
                          ประเภทการซื้อรถเข้า
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="person_vat_id"
                          name="person_vat_id"
                          value={
                            this.state.person_vat_id
                              ? CarUtil.convertPersonVatIdToName(
                                  this.state.person_vat_id
                                )
                              : "-"
                          }
                          disabled
                        />
                      </div>
                      <div className="form-group col-sm-4">
                        <label htmlFor="car_sell_type">ประเภทการขาย</label>
                        <select
                          className="form-control"
                          id="car_sell_type_id"
                          ref="car_sell_type_id"
                          name="car_sell_type_id"
                          onChange={this.onInputChangeCarSellEdit}
                          value={this.state.car_sell_type_id}
                        >
                          <option> เลือกประเภทการขาย </option>
                          {car_sell_type_list}
                        </select>
                      </div>
                      <div className="form-group col-sm-4">
                        <label htmlFor="bank_finance_id">ไฟแนนซ์</label>
                        <select
                          className="form-control"
                          id="bank_finance_id"
                          name="bank_finance_id"
                          ref="bank_finance_id"
                          onChange={this.onInputChangeCarSellEdit}
                          value={this.state.bank_finance_id}
                        >
                          <option> เลือกธนาคาร </option>
                          {bank_finance_list}
                        </select>
                      </div>
                    </div>

                    <div className="row">
                      <div className="form-group col-sm-3">
                        <label htmlFor="normal_sell_price">ราคาปกติ</label>
                        <input
                          type="text"
                          className="form-control hidden"
                          id="normal_sell_price"
                          name="normal_sell_price"
                          placeholder=""
                          ref="normal_sell_price"
                          value={this.state.normal_sell_price}
                          onChange={() => {}}
                        />
                        {normal_sell_price}
                      </div>

                      <div className="form-group col-sm-3">
                        <label htmlFor="real_sell_price">ราคาขายจริง</label>
                        <input
                          type="text"
                          className="form-control hidden"
                          id="real_sell_price"
                          name="real_sell_price"
                          placeholder=""
                          ref="real_sell_price"
                          value={this.state.real_sell_price}
                          onChange={() => {}}
                        />
                        <NumberFormat
                          className="form-control"
                          thousandSeparator={true}
                          prefix={"฿"}
                          //placeholder="กรอกค่าโอน"
                          min={0}
                          max={1000000000}
                          step={1000}
                          size={10}
                          allowNegative={false}
                          value={this.state.real_sell_price}
                          onValueChange={(values) => {
                            const { value } = values;
                            this.setState({ real_sell_price: value }, () => {
                              this.handleOnChangeCarSellEditPrice();
                            });
                          }}
                        />
                      </div>

                      <div className="form-group col-sm-3 has-warning">
                        <label htmlFor="car_over_sales">ยอดขายเกิน</label>
                        <input
                          type="text"
                          className="form-control hidden"
                          id="car_over_sales"
                          name="car_over_sales"
                          placeholder=""
                          ref="car_over_sales"
                          value={this.state.car_over_sales}
                          onChange={() => {}}
                        />
                        <NumberFormat
                          className="form-control text-primary"
                          thousandSeparator={true}
                          prefix={"฿"}
                          //placeholder="กรอกค่าโอน"
                          min={0}
                          max={1000000000}
                          step={1000}
                          size={10}
                          allowNegative={true}
                          value={this.state.car_over_sales}
                          displayType="text"
                        />
                      </div>

                      <div className="form-group col-sm-3">
                        <label htmlFor="car_sell_discount">ส่วนลด</label>
                        <input
                          readOnly
                          type="text"
                          className="form-control hidden"
                          id="car_sell_discount"
                          name="car_sell_discount"
                          placeholder=""
                          ref="car_sell_discount"
                          value={this.state.car_sell_discount}
                          onChange={() => {}}
                        />
                        <NumberFormat
                          className="form-control"
                          thousandSeparator={true}
                          prefix={"฿"}
                          //placeholder="กรอกค่าโอน"
                          min={0}
                          max={1000000000}
                          step={1000}
                          size={10}
                          allowNegative={true}
                          value={this.state.car_sell_discount}
                          displayType="text"
                        />
                      </div>

                      <div className="form-group col-sm-3">
                        <label htmlFor="rate_finance">ยอดจัดไฟแนนซ์</label>
                        <input
                          type="text"
                          className="form-control hidden"
                          id="rate_finance"
                          name="rate_finance"
                          placeholder=""
                          ref="rate_finance"
                          value={this.state.rate_finance}
                          onChange={() => {}}
                        />
                        <NumberFormat
                          className="form-control"
                          thousandSeparator={true}
                          prefix={"฿"}
                          //placeholder="กรอกค่าโอน"
                          min={0}
                          max={1000000000}
                          step={1000}
                          size={10}
                          allowNegative={false}
                          value={this.state.rate_finance}
                          onValueChange={(values) => {
                            const { value } = values;
                            let sum_down =
                              Number(this.state.real_sell_price) -
                              Number(value);
                            this.setState(
                              { rate_finance: value, sum_down: sum_down },
                              () => {
                                this.handleOnChangeCarSellEditPrice();
                              }
                            );
                          }}
                        />
                      </div>

                      <div className="form-group col-sm-3 hidden">
                        <label htmlFor="insurance_pa">ประกัน PA</label>
                        <input
                          type="text"
                          className="form-control hidden"
                          id="insurance_pa"
                          name="insurance_pa"
                          placeholder=""
                          ref="insurance_pa"
                          value={this.state.insurance_pa}
                          onChange={() => {}}
                        />
                        <NumberFormat
                          className="form-control"
                          thousandSeparator={true}
                          prefix={"฿"}
                          //placeholder="กรอกค่าโอน"
                          min={0}
                          max={1000000000}
                          step={1000}
                          size={10}
                          allowNegative={false}
                          value={this.state.insurance_pa}
                          onValueChange={(values) => {
                            const { value } = values;
                            this.setState({ insurance_pa: value }, () => {
                              this.handleOnChangeCarSellEditPrice();
                            });
                          }}
                        />
                      </div>

                      <div className="form-group col-sm-3 hidden">
                        <label htmlFor="bank">ภาษียอดจัดไฟแนนซ์</label>
                        <input
                          type="text"
                          className="form-control hidden"
                          id="tax_rate_finance"
                          name="tax_rate_finance"
                          placeholder=""
                          ref="tax_rate_finance"
                          value={this.state.tax_rate_finance}
                          onChange={() => {}}
                        />
                        <NumberFormat
                          className="form-control"
                          thousandSeparator={true}
                          prefix={"฿"}
                          //placeholder="กรอกค่าโอน"
                          min={0}
                          max={1000000000}
                          step={1000}
                          size={10}
                          allowNegative={false}
                          value={this.state.tax_rate_finance}
                          onValueChange={(values) => {
                            const { value } = values;
                            this.setState({ tax_rate_finance: value }, () => {
                              this.handleOnChangeCarSellEditPrice();
                            });
                          }}
                        />
                      </div>

                      <div className="form-group col-sm-3 hidden">
                        <label htmlFor="total_rate_finance">
                          รวมมูลค่ายอดจัดไฟแนนซ์
                        </label>
                        <input
                          readOnly
                          type="text"
                          className="form-control hidden"
                          id="total_rate_finance"
                          name="total_rate_finance"
                          placeholder=""
                          ref="total_rate_finance"
                          value={this.state.total_rate_finance}
                          onChange={() => {}}
                        />
                        <NumberFormat
                          className="form-control"
                          thousandSeparator={true}
                          prefix={"฿"}
                          //placeholder="กรอกค่าโอน"
                          min={0}
                          max={1000000000}
                          step={1000}
                          size={10}
                          allowNegative={false}
                          value={this.state.total_rate_finance}
                          displayType="text"
                        />
                      </div>

                      <div className="form-group col-sm-3">
                        <label htmlFor="sum_down">ยอดดาวน์</label>
                        <input
                          type="text"
                          className="form-control hidden"
                          id="sum_down"
                          name="sum_down"
                          placeholder=""
                          ref="sum_down"
                          value={this.state.sum_down}
                          onChange={() => {}}
                        />
                        <NumberFormat
                          className="form-control"
                          thousandSeparator={true}
                          prefix={"฿"}
                          //placeholder="กรอกค่าโอน"
                          min={0}
                          max={1000000000}
                          step={1000}
                          size={10}
                          allowNegative={false}
                          value={this.state.sum_down}
                          onValueChange={(values) => {
                            const { value } = values;
                            this.setState({ sum_down: value }, () => {
                              this.handleOnChangeCarSellEditPrice();
                            });
                          }}
                        />
                      </div>

                      <div className="form-group col-sm-2 has-warning">
                        <label htmlFor="sum_down">ยอดจัดเกิน</label>
                        <input
                          type="text"
                          className="form-control hidden"
                          id="car_excess_amount"
                          name="car_excess_amount"
                          placeholder=""
                          ref="car_excess_amount"
                          value={this.state.car_excess_amount}
                          onChange={() => {}}
                        />
                        <NumberFormat
                          className="form-control text-primary"
                          thousandSeparator={true}
                          prefix={"฿"}
                          //placeholder="กรอกค่าโอน"
                          min={0}
                          max={1000000000}
                          step={1000}
                          size={10}
                          allowNegative={false}
                          value={this.state.car_excess_amount}
                          displayType="text"
                          disabled={this.state.car_sell_type_id === "1"}
                        />
                      </div>

                      <div className="form-group col-sm-2 hidden">
                        <label htmlFor="insurance_company">บริษัทประกัน</label>
                        <select
                          className="form-control"
                          id="insurance_company_id"
                          name="insurance_company_id"
                          ref="insurance_company_id"
                          onChange={this.onInputChangeCarSellEdit}
                          value={this.state.insurance_company_id}
                        >
                          <option> เลือกบริษัทประกัน </option>
                          {insurance_company_list}
                        </select>
                      </div>

                      <div className="form-group col-sm-2">
                        <label htmlFor="insurance_type">ประเภทประกัน</label>
                        <select
                          className="form-control"
                          id="insurance_type_id"
                          name="insurance_type_id"
                          ref="insurance_type_id"
                          onChange={this.onInputChangeCarSellEdit}
                          value={this.state.insurance_type_id || "0"}
                        >
                          <option value="0"> เลือกประเภทประกัน </option>
                          {insurance_type_list}
                        </select>
                      </div>

                      <div className="form-group col-sm-2">
                        <label htmlFor="insurance_price">ราคาประกัน</label>
                        <input
                          type="text"
                          className="form-control hidden"
                          id="insurance_price"
                          name="insurance_price"
                          placeholder=""
                          ref="insurance_price"
                          value={this.state.insurance_price}
                          onChange={() => {}}
                        />
                        <NumberFormat
                          className="form-control"
                          thousandSeparator={true}
                          prefix={"฿"}
                          //placeholder="กรอกค่าโอน"
                          min={0}
                          max={1000000000}
                          step={1000}
                          size={10}
                          allowNegative={false}
                          value={this.state.insurance_price}
                          onValueChange={(values) => {
                            const { value } = values;
                            var insurance_price_old =
                              this.state.insurance_price;

                            this.setState({ insurance_price: value }, () => {
                              this.handleOnChangeInsurancePriceEdit(
                                insurance_price_old
                              );
                            });
                          }}
                        />
                      </div>

                      <div className="form-group col-sm-3">
                        <label htmlFor="cost_finance">
                          ค่าจัดไฟแนนซ์+ค่าโอน
                        </label>
                        <input
                          type="text"
                          className="form-control hidden"
                          id="cost_finance"
                          name="cost_finance"
                          placeholder=""
                          ref="cost_finance"
                          value={this.state.cost_finance}
                          onChange={() => {}}
                        />
                        <NumberFormat
                          className="form-control"
                          thousandSeparator={true}
                          prefix={"฿"}
                          //placeholder="กรอกค่าโอน"
                          min={0}
                          max={1000000000}
                          step={1000}
                          size={10}
                          allowNegative={false}
                          value={this.state.cost_finance}
                          onValueChange={(values) => {
                            const { value } = values;
                            this.setState({ cost_finance: value }, () => {
                              this.handleOnChangeCarSellEditPrice();
                            });
                          }}
                        />
                      </div>

                      <div className="form-group col-sm-3">
                        <label htmlFor="duration_period_id">
                          ระยะเวลาผ่อนชำระ
                        </label>
                        <select
                          className="form-control"
                          id="duration_period_id"
                          name="duration_period_id"
                          ref="duration_period_id"
                          onChange={this.onInputChangeCarSellEdit}
                          value={this.state.duration_period_id}
                        >
                          <option> เลือกระยะเวลาผ่อนชำระ </option>
                          {duration_period_list}
                        </select>
                      </div>

                      {/* new item for nkmahachai start */}
                      <div className="form-group col-sm-3">
                        <label htmlFor="insurance_buy">การซื้อประกัน</label>
                        {/* <div className="form-control">
                                              {this.state.insurance_buy}
                                            </div> */}
                        <div
                          className="btn-group colors"
                          style={{ height: 36, padding: 10 }}
                        >
                          <input
                            type="radio"
                            name="insurance_buy"
                            value="ประกันแถม"
                            className="btn btn-primary"
                            defaultChecked={
                              this.state.insurance_buy === "ประกันแถม"
                            }
                            onChange={this.onInsuranceBuyChanged}
                          />{" "}
                          &nbsp;<span style={{ marginTop: -4 }}>ประกันแถม</span>
                          &nbsp;&nbsp;&nbsp;&nbsp;
                          <input
                            type="radio"
                            name="insurance_buy"
                            value="ซื้อเอง"
                            className="btn btn-primary"
                            defaultChecked={
                              this.state.insurance_buy === "ซื้อเอง"
                            }
                            onChange={this.onInsuranceBuyChanged}
                          />{" "}
                          &nbsp;<span style={{ marginTop: -4 }}>ซื้อเอง</span>
                        </div>
                      </div>

                      <div className="form-group col-sm-3">
                        <label htmlFor="promotion_name">
                          ชื่อโปรโมชั่น &nbsp;
                          <input
                            type="checkbox"
                            name="promotion_oil"
                            checked={this.state.promotion_oil === "ฟรีน้ำมัน"}
                            onChange={(e) => {
                              let isCheck = e.target.checked;
                              if (isCheck) {
                                this.setState({ promotion_oil: "ฟรีน้ำมัน" });
                              } else {
                                this.setState({ promotion_oil: "-" });
                              }
                            }}
                          />{" "}
                          ฟรีน้ำมัน
                        </label>
                        {/* <div className="form-control">
                                              {this.state.promotion_name}
                                            </div> */}
                        <select
                          className="form-control"
                          id="promotion_name"
                          name="promotion_name"
                          ref="promotion_name"
                          value={this.state.promotion_name}
                          onChange={(e) => {
                            if (this.state.user.type === "admin")
                              this.setState({ promotion_name: e.target.value });
                          }}
                        >
                          <option value=""> ระบุโปรโมชั่น </option>
                          {promotion_list}
                        </select>
                      </div>

                      {/* new item for nkmahachai end */}

                      {/*<div className="form-group col-sm-3 hidden">
                                                <label htmlFor="cost_transfer">ค่าโอน</label>
                                                <input type="text"
                                                       className="form-control hidden"
                                                       id="cost_transfer"
                                                       name="cost_transfer"
                                                       placeholder=""
                                                       ref="cost_transfer"
                                                       value={this.state.cost_transfer}
                                                />
                                                <NumberFormat
                                                    className="form-control"
                                                    thousandSeparator={true}
                                                    prefix={'฿'}
                                                    //placeholder="กรอกค่าโอน"
                                                    min={0}
                                                    max={1000000000}
                                                    step={1000}
                                                    size={10}
                                                    allowNegative={false}
                                                    value={this.state.cost_transfer}
                                                    onValueChange = {(values) => {
                                                        const {value} = values;
                                                        this.setState({cost_transfer: value},()=>{
                                                            this.handleOnChangeCarSellEditPrice();
                                                        })

                                                    }}
                                                />
                                            </div>*/}

                      {/*<div className="form-group col-sm-3 hidden">
                                                <label htmlFor="cost_period_month">ค่างวดล่วงหน้า/เดือน</label>
                                                <input type="text"
                                                       className="form-control hidden"
                                                       id="cost_period_month"
                                                       name="cost_period_month"
                                                       placeholder=""
                                                       ref="cost_period_month"
                                                       value={this.state.cost_period_month}
                                                />
                                                <NumberFormat
                                                    className="form-control"
                                                    thousandSeparator={true}
                                                    prefix={'฿'}
                                                    //placeholder="กรอกค่าโอน"
                                                    min={0}
                                                    max={1000000000}
                                                    step={1000}
                                                    size={10}
                                                    allowNegative={false}
                                                    value={this.state.cost_period_month}
                                                    onValueChange = {(values) => {
                                                        const {value} = values;
                                                        this.setState({cost_period_month: value},()=>{
                                                            this.handleOnChangeCarSellEditPrice();
                                                        })

                                                    }}
                                                />
                                            </div>*/}

                      {/*<div className="form-group col-sm-3 hidden">
                                                <label htmlFor="count_period">จำนวนงวด</label>
                                                <select
                                                    className="form-control"
                                                    id="count_period_id"
                                                    name="count_period_id"
                                                    ref="count_period_id"
                                                    onChange={this.onInputChangeCarSellEdit}
                                                    value={this.state.count_period_id}
                                                >
                                                    <option> เลือกจำนวนงวด </option>
                                                    {count_period_list}
                                                </select>
                                            </div>*/}

                      {/*<div className="form-group col-sm-4 hidden">
                                                <label htmlFor="total_cost_period_call">รวมค่างวดที่เรียกเก็บ</label>
                                                <input readOnly
                                                       type="text"
                                                       className="form-control hidden"
                                                       id="total_cost_period_call"
                                                       name="total_cost_period_call"
                                                       placeholder=""
                                                       ref="total_cost_period_call"
                                                       value={this.state.total_cost_period_call}
                                                />
                                                <NumberFormat
                                                    className="form-control"
                                                    thousandSeparator={true}
                                                    prefix={'฿'}
                                                    //placeholder="กรอกค่าโอน"
                                                    min={0}
                                                    max={1000000000}
                                                    step={1000}
                                                    size={10}
                                                    allowNegative={false}
                                                    value={this.state.total_cost_period_call}
                                                    displayType="text"
                                                />
                                            </div>*/}

                      <div className="form-group col-sm-3">
                        <label htmlFor="cost_finance">ค่านายหน้า</label>
                        <input
                          type="text"
                          className="form-control hidden"
                          id="car_external_commission"
                          name="car_external_commission"
                          placeholder=""
                          ref="car_external_commission"
                          value={this.state.car_external_commission}
                          onChange={() => {}}
                        />
                        <NumberFormat
                          className="form-control"
                          thousandSeparator={true}
                          prefix={"฿"}
                          //placeholder="กรอกค่าโอน"
                          min={0}
                          max={1000000000}
                          step={1000}
                          size={10}
                          allowNegative={false}
                          value={this.state.car_external_commission}
                          onValueChange={(values) => {
                            const { value } = values;
                            this.setState(
                              { car_external_commission: value },
                              () => {
                                this.handleOnChangeCarPriceOutof();
                              }
                            );
                          }}
                        />
                      </div>

                      <div className="form-group has-warning col-sm-3">
                        <label htmlFor="total_outof_car">รวมออกรถ/บาท</label>
                        <input
                          readOnly
                          type="text"
                          className="form-control hidden"
                          id="total_outof_car"
                          name="total_outof_car"
                          placeholder=""
                          ref="total_outof_car"
                          value={this.state.total_outof_car}
                          onChange={() => {}}
                        />
                        <NumberFormat
                          className="form-control"
                          thousandSeparator={true}
                          prefix={"฿"}
                          //placeholder="กรอกค่าโอน"
                          min={0}
                          max={1000000000}
                          step={1000}
                          size={10}
                          allowNegative={false}
                          value={this.state.total_outof_car}
                          displayType="text"
                        />
                      </div>

                      <div className="form-group has-danger col-sm-3">
                        <label htmlFor="balance_debt">
                          ยอดคงเหลือค้างชำระ/บาท
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="balance_debt"
                          name="balance_debt"
                          ref="balance_debt"
                          placeholder=""
                          value={this.state.balance_debt}
                          onChange={this.onInputChangeCarSellEdit}
                        />
                        {/*<NumberFormat
                                                    className="form-control"
                                                    thousandSeparator={true}
                                                    prefix={'฿'}
                                                    //placeholder="กรอกค่าโอน"
                                                    min={0}
                                                    max={1000000000}
                                                    step={1000}
                                                    size={10}
                                                    allowNegative={false}
                                                    displayType="text"
                                                    ref="balance_debt"
                                                    value={this.state.balance_debt}
                                                    onChange={this.onInputChangeCarSellEdit}
                                                />*/}
                      </div>

                      <div className="form-group has-success col-sm-3">
                        <label htmlFor="total_outof_car">เงินคืนลูกค้า</label>
                        <input
                          type="text"
                          className="form-control hidden"
                          id="customer_cash"
                          name="customer_cash"
                          placeholder=""
                          ref="customer_cash"
                          value={this.state.customer_cash}
                          onChange={() => {}}
                        />
                        <NumberFormat
                          className="form-control text-primary"
                          thousandSeparator={true}
                          prefix={"฿"}
                          //placeholder="เงินคืนลูกค้า"
                          min={0}
                          max={1000000000}
                          step={1000}
                          size={10}
                          allowNegative={false}
                          value={this.state.customer_cash}
                          displayType="text"
                        />
                      </div>

                      <div className="form-group col-sm-3">
                        <label htmlFor="car_sell_status">สถานะ</label>
                        <select
                          className="form-control"
                          id="car_status_id"
                          name="car_status_id"
                          ref="car_status_id"
                          onChange={this.onInputChangeCarSellEdit}
                          value={this.state.car_status_id}
                        >
                          {car_sell_status_list}
                        </select>
                      </div>

                      <div className="form-group col-sm-3">
                        <label htmlFor="date_promise">วันที่ทำสัญญา </label>
                        <DatePicker
                          selected={this.state.startDatePromiseEdit}
                          onChange={this.handleDatePromise}
                          dateFormat="yyyy-MM-dd"
                          type="text"
                          className="form-control"
                          id="date_promise"
                          name="date_promise"
                          ref="date_promise"
                          value={this.state.date_promise}
                          placeholder=""
                        />
                      </div>
                      <div className="form-group col-sm-3">
                        <label htmlFor="insurance_start_date">
                          วันที่เริ่มประกันรถ{" "}
                        </label>
                        <br />
                        <DatePicker
                          selected={this.state.insuranceStartDate}
                          onChange={this.handleInsuranceStartDate}
                          dateFormat="yyyy-MM-dd"
                          type="text"
                          className="form-control"
                          id="insurance_start_date"
                          name="insurance_start_date"
                          value={this.state.insurance_start_date}
                          placeholder=""
                        />
                      </div>

                      <div className="form-group col-sm-3">
                        <label htmlFor="insurance_tel">เบอร์โทรประกันรถ </label>
                        <input
                          type="text"
                          className="form-control"
                          id="insurance_tel"
                          name="insurance_tel"
                          placeholder=""
                          value={this.state.insurance_tel}
                          onChange={(event) => {
                            this.setState({
                              insurance_tel: event.target.value,
                            });
                          }}
                        />
                      </div>

                      <div className="form-group col-sm-3">
                        <label htmlFor="pay_advance_finance">
                          เก็บค่างวดรถล่วงหน้า
                        </label>
                        <input
                          type="text"
                          className="form-control hidden"
                          id="pay_advance_finance"
                          name="pay_advance_finance"
                          placeholder=""
                          ref="pay_advance_finance"
                          value={this.state.pay_advance_finance}
                          onChange={() => {}}
                        />
                        <NumberFormat
                          className="form-control"
                          thousandSeparator={true}
                          prefix={"฿"}
                          //placeholder="กรอกค่าโอน"
                          min={0}
                          max={1000000000}
                          step={1000}
                          size={10}
                          allowNegative={false}
                          value={this.state.pay_advance_finance}
                          onValueChange={(values) => {
                            const { value } = values;
                            this.setState(
                              { pay_advance_finance: value },
                              () => {
                                this.handleOnChangeCarPriceOutof();
                              }
                            );
                          }}
                        />
                      </div>

                      <div className="form-group col-sm-3">
                        <label htmlFor="gearbox_warranty">
                          ประกันเครื่องเกียร์
                        </label>
                        <select
                          className="form-control"
                          id="gearbox_warranty"
                          name="gearbox_warranty"
                          value={this.state.gearbox_warranty}
                          onChange={(e) => {
                            let val = e.target.value;
                            this.setState(
                              {
                                gearbox_warranty: val,
                              },
                              () => {
                                if (val === "ไม่รับประกันเครื่องเกียร์") {
                                  this.setState({
                                    gearbox_bank_name: "",
                                  });
                                }
                              }
                            );
                          }}
                        >
                          <option value=""> ระบุการประกันเครื่องเกียร์ </option>
                          {gearbox_warranty_list}
                        </select>
                      </div>

                      <div className="form-group col-sm-3">
                        <label htmlFor="gearbox_warranty">
                          ธนาคาร(เครื่องเกียร์)
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="gearbox_bank_name"
                          name="gearbox_bank_name"
                          maxLength={100}
                          placeholder=""
                          value={this.state.gearbox_bank_name}
                          disabled={
                            this.state.gearbox_warranty !==
                            "รับประกันเครื่องเกียร์"
                          }
                          onChange={(event) => {
                            this.setState({
                              gearbox_bank_name: event.target.value,
                            });
                          }}
                        />
                      </div>

                      <div className="form-group col-sm-3">
                        <label htmlFor="tent_warranty">
                          การรับประกันของเต็นท์
                        </label>
                        <select
                          className="form-control"
                          id="tent_warranty"
                          name="tent_warranty"
                          value={this.state.tent_warranty}
                          onChange={(e) => {
                            let val = e.target.value;
                            this.setState({
                              tent_warranty: val,
                            });
                          }}
                        >
                          {tent_warranty_list}
                        </select>
                      </div>
                    </div>

                    <div
                      className="row"
                      style={styles.bottomLineAndMargin}
                    ></div>

                    <div
                      className="row"
                      style={{
                        ...styles.bottomLineAndMargin,
                        marginTop: "8px",
                      }}
                    >
                      <div className="form-group col-sm-2">
                        <h6>โปรโมชั่น</h6>
                      </div>

                      <div className="form-group col-sm-3">
                        <label htmlFor="promotion_oil_cost">
                          โปรโมชั่นน้ำมัน(บาท)
                        </label>
                        <input
                          type="text"
                          className="form-control hidden"
                          id="promotion_oil_cost"
                          name="promotion_oil_cost"
                          placeholder=""
                          ref="promotion_oil_cost"
                          value={this.state.promotion_oil_cost}
                          onChange={() => {}}
                        />
                        <NumberFormat
                          className="form-control"
                          thousandSeparator={true}
                          prefix={"฿"}
                          min={0}
                          max={1000000000}
                          step={1000}
                          size={10}
                          allowNegative={false}
                          placeholder={"โปรโมชั่นน้ำมัน"}
                          value={this.state.promotion_oil_cost}
                          onValueChange={(values) => {
                            const { value } = values;
                            this.setState({
                              promotion_oil_cost: value,
                            });
                          }}
                          onBlur={() => {
                            this.calPromotion();
                          }}
                        />
                      </div>

                      <div className="form-group col-sm-3">
                        <label htmlFor="promotion_discount_cost">
                          โปรโมชั่นส่วนลด(บาท)
                        </label>
                        <input
                          type="text"
                          className="form-control hidden"
                          id="promotion_discount_cost"
                          name="promotion_discount_cost"
                          placeholder=""
                          ref="promotion_discount_cost"
                          value={this.state.promotion_discount_cost}
                          onChange={() => {}}
                        />
                        <NumberFormat
                          className="form-control"
                          thousandSeparator={true}
                          prefix={"฿"}
                          min={0}
                          max={1000000000}
                          step={1000}
                          size={10}
                          allowNegative={false}
                          placeholder={"โปรโมชั่นส่วนลด"}
                          value={this.state.promotion_discount_cost}
                          onValueChange={(values) => {
                            const { value } = values;
                            this.setState({
                              promotion_discount_cost: value,
                            });
                          }}
                          onBlur={() => {
                            this.calPromotion();
                          }}
                        />
                      </div>

                      <div className="form-group col-sm-3">
                        <label htmlFor="promotion_help_cost">
                          โปรโมชั่นช่วยผ่อน(บาท)
                        </label>
                        <input
                          type="text"
                          className="form-control hidden"
                          id="promotion_help_cost"
                          name="promotion_help_cost"
                          placeholder=""
                          ref="promotion_help_cost"
                          value={this.state.promotion_help_cost}
                          onChange={() => {}}
                        />
                        <NumberFormat
                          className="form-control"
                          thousandSeparator={true}
                          prefix={"฿"}
                          min={0}
                          max={1000000000}
                          step={1000}
                          size={10}
                          allowNegative={false}
                          placeholder={"โปรโมชั่นช่วยผ่อน"}
                          value={this.state.promotion_help_cost}
                          onValueChange={(values) => {
                            const { value } = values;
                            this.setState({
                              promotion_help_cost: value,
                            });
                          }}
                          onBlur={() => {
                            this.calPromotion();
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="card-footer text-right">
                <button
                  type="reset"
                  className="btn btn-sm btn-danger"
                  onClick={this.props.onToggle}
                >
                  <i className="fa fa-refresh"></i> ยกเลิก
                </button>
                <button type="submit" className="btn btn-sm btn-warning">
                  <i className="fa fa-save"></i> แก้ไขการขาย
                </button>
              </div>
            </div>
          </div>
        </div>
      </form>
    );
  }
}

const styles = {
  bottomLine: {
    borderBottomColor: "#ccc",
    borderBottomStyle: "solid",
    borderWidth: 0.5,
  },
  bottomLineAndMargin: {
    borderBottomColor: "#ccc",
    borderBottomStyle: "solid",
    borderWidth: 0.5,
    paddingTop: 8,
  },
};

export default SalesEdit;
